module.exports = "<a ng-disabled=!date class=\"btn btn-default btn-xs\" ng-href={{url}}><span class=\"glyphicon glyphicon-remove-circle\" aria-hidden=true></span>&nbsp; <span class=\"hidden-xs ng-scope\" translate=STREAMING>Streaming</span></a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/rightsStreamingReport.html
// module id = 438
// module chunks = 0